import { Button } from "@/components/Buttons";
import { ReadOnlyField, SelectField, TextField, TextAreaField, HiddenField, SingleCheckboxField } from "@/components/Form/Parts/index";
import { inquiryList } from "@/lib/constants";
import formStyles from "@/styles/Form.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import isEmpty from "lodash/isEmpty";
import Link from "next/link";
import { useEffect, useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import * as y from "yup";
import config from "@/lib/config";
import yupInquiryNameValidate from "@/lib/yupInquiryNameValidate";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function createOption(value, format) {
  return {
    value: value,
    label: format
  };
}
function inquiryOptions() {
  const options = [];
  for (const key in inquiryList) {
    options.push(createOption(key, inquiryList[key]));
  }
  return options;
}
yupInquiryNameValidate(y);
export default function Step1(_ref) {
  var _errors$fullName, _errors$mailAddress, _errors$commentOption, _errors$comment, _errors$privacypolicy;
  let {
    onSubmit,
    user,
    formData,
    privacypolicy
  } = _ref;
  let schema;
  if (user) {
    schema = y.object().shape({
      commentOption: y.string().required("お問い合わせ内容を選択してください。"),
      comment: y.string().max(2000, "2000文字以内で入力してください。").required("お問い合わせ詳細を入力してください。")
    });
  } else {
    schema = y.object().shape({
      fullName: y.string().required("お名前を入力してください。").matches(/^([^\x01-\x7E\uFF65-\uFF9F]| )+$/, "お名前は全角文字で入力してください。").max(20, "20文字以内で入力してください。").inquiryName(),
      mailAddress: y.string().email("メールアドレスの形式で入力してください。").required("メールアドレスが入力されていません。"),
      commentOption: y.string().required("お問い合わせ内容を選択してください。"),
      comment: y.string().max(2000, "2000文字以内で入力してください。").required("お問い合わせ詳細を入力してください。"),
      privacypolicy: y.boolean().oneOf([true], "規約に同意してください。")
    });
  }
  const {
    formState,
    register,
    handleSubmit,
    errors,
    setValue,
    trigger
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all"
  });
  useEffect(() => {
    if (!isEmpty(formData)) {
      setValue("commentOption", createOption(formData === null || formData === void 0 ? void 0 : formData.commentOption, inquiryList[formData === null || formData === void 0 ? void 0 : formData.commentOption]), {
        shouldValidate: true,
        shouldDirty: true
      });
      setValue("fullName", (formData === null || formData === void 0 ? void 0 : formData.fullName) || (user === null || user === void 0 ? void 0 : user.fullName), {
        shouldValidate: true,
        shouldDirty: true
      });
      setValue("mailAddress", (formData === null || formData === void 0 ? void 0 : formData.mailAddress) || (user === null || user === void 0 ? void 0 : user.mailAddress), {
        shouldValidate: true,
        shouldDirty: true
      });
      setValue("comment", formData === null || formData === void 0 ? void 0 : formData.comment, {
        shouldValidate: true,
        shouldDirty: true
      });
    }
  }, [formData, user]);
  const {
    isDirty,
    isValid,
    isSubmitting
  } = formState;
  const {
    0: commentOption,
    1: setCommentOption
  } = useState((formData === null || formData === void 0 ? void 0 : formData.commentOption) || "");
  const isLoggedIn = Boolean(user);
  const handleCommentOptionChange = useCallback(e => {
    setCommentOption(e.value);
  }, []);
  useEffect(() => {
    if (commentOption) {
      trigger("commentOption");
    }
  }, [commentOption]);
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit(onSubmit),
    noValidate: true,
    children: [/*#__PURE__*/_jsx("div", {
      className: processStyles.contentWrapper,
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.content,
        children: [/*#__PURE__*/_jsxs("p", {
          children: ["\u203B\u304A\u554F\u3044\u5408\u308F\u305B\u306E\u524D\u306B\uFF1A\u3088\u304F\u3042\u308B\u3054\u8CEA\u554F\u306F", /*#__PURE__*/_jsx(Link, {
            href: config.staticLinks.help,
            target: "_blank",
            rel: "noopener noreferrer",
            className: formStyles.textLink,
            children: "\u3053\u3061\u3089"
          }), "\u304B\u3089\u3054\u78BA\u8A8D\u3044\u305F\u3060\u3051\u307E\u3059\u3002"]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("p", {
          className: `${processStyles.contentHeader} ${processStyles.mailForm}`,
          children: ["\u304A\u554F\u3044\u5408\u308F\u305B\u306E\u5185\u5BB9\u306B\u3088\u3063\u3066\u306F\u3001\u56DE\u7B54\u306B\u304A\u6642\u9593\u3092\u8981\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u3042\u3089\u304B\u3058\u3081\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u304C\u6B63\u3057\u304F\u306A\u3044\u5834\u5408\u306F\u8FD4\u4FE1\u3067\u304D\u307E\u305B\u3093\u306E\u3067\u3001\u3054\u6CE8\u610F\u306E\u3046\u3048\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u4F1A\u54E1\u306E\u65B9\u306F\u30ED\u30B0\u30A4\u30F3\u3057\u305F\u3046\u3048\u3067\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"]
        }), /*#__PURE__*/_jsx("fieldset", {
          className: `${formStyles.basicFieldset} ${formStyles.marginOff}`,
          children: /*#__PURE__*/_jsx("div", {
            className: formStyles.inputField,
            children: /*#__PURE__*/_jsxs("div", {
              className: formStyles.formGroup,
              children: [!isLoggedIn && /*#__PURE__*/_jsx(TextField, {
                ref: register,
                title: "\u540D\u524D\uFF08\u6F22\u5B57\u3001\u53C8\u306F\u30AB\u30CA\uFF09",
                caption: "\u203BSPOOX\u3067\u4F1A\u54E1\u767B\u9332\u6E08\u307F\u306E\u65B9\u306F\u3001\u4F1A\u54E1\u767B\u9332\u6642\u306E\u304A\u540D\u524D\u3067\u5165\u529B\u3092\u304A\u9858\u3044\u3057\u307E\u3059\u3002",
                name: "fullName",
                placeholder: "\u304A\u540D\u524D",
                error: (_errors$fullName = errors.fullName) === null || _errors$fullName === void 0 ? void 0 : _errors$fullName.message,
                required: true
              }), isLoggedIn && /*#__PURE__*/_jsx(ReadOnlyField, {
                title: "\u540D\u524D",
                name: "fullName",
                value: user === null || user === void 0 ? void 0 : user.fullName,
                required: true
              })]
            })
          })
        }), /*#__PURE__*/_jsxs("fieldset", {
          className: formStyles.basicFieldset,
          children: [!isLoggedIn && /*#__PURE__*/_jsx(TextField, {
            ref: register,
            title: "E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
            placeholder: "E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
            name: "mailAddress",
            error: (_errors$mailAddress = errors.mailAddress) === null || _errors$mailAddress === void 0 ? void 0 : _errors$mailAddress.message,
            required: true
          }), isLoggedIn && /*#__PURE__*/_jsx(ReadOnlyField, {
            name: "mailAddress",
            value: user === null || user === void 0 ? void 0 : user.mailAddress,
            title: "E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
            required: true
          })]
        }), /*#__PURE__*/_jsxs("fieldset", {
          className: formStyles.basicFieldset,
          children: [/*#__PURE__*/_jsx(SelectField, {
            title: "\u304A\u554F\u3044\u5408\u308F\u305B\u5185\u5BB9",
            options: inquiryOptions(),
            name: "commentOption",
            placeholder: "\u304A\u554F\u3044\u5408\u308F\u305B\u5185\u5BB9",
            onChange: handleCommentOptionChange,
            defaultValue: (formData === null || formData === void 0 ? void 0 : formData.commentOption) && createOption(formData === null || formData === void 0 ? void 0 : formData.commentOption, inquiryList[formData === null || formData === void 0 ? void 0 : formData.commentOption]),
            error: (_errors$commentOption = errors.commentOption) === null || _errors$commentOption === void 0 ? void 0 : _errors$commentOption.message,
            required: true
          }), /*#__PURE__*/_jsx(HiddenField, {
            ref: register,
            name: "commentOption",
            value: commentOption
          })]
        }), /*#__PURE__*/_jsx("fieldset", {
          className: formStyles.basicFieldset,
          children: /*#__PURE__*/_jsx(TextAreaField, {
            ref: register,
            title: "\u304A\u554F\u3044\u5408\u308F\u305B\u5185\u5BB9\u306E\u8A73\u7D30",
            name: "comment",
            placeholder: "\u30B3\u30E1\u30F3\u30C8",
            error: (_errors$comment = errors.comment) === null || _errors$comment === void 0 ? void 0 : _errors$comment.message,
            required: true
          })
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: formStyles.guideArea,
      children: [/*#__PURE__*/_jsx("p", {
        children: "\u4F7F\u7528\u3057\u3066\u3044\u308B\u7AEF\u672B\uFF08\u30D1\u30BD\u30B3\u30F3\u3001\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u3001\u30BF\u30D6\u30EC\u30C3\u30C8\u7B49\uFF09\u3084\u3001\u3054\u5229\u7528\u306E\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u74B0\u5883\u306A\u3069\u306E\u60C5\u5831\u3092\u6DFB\u3048\u3066\u3001\u304A\u554F\u3044\u5408\u308F\u305B\u306E\u5185\u5BB9\u306F\u3067\u304D\u308B\u3060\u3051\u8A73\u3057\u304F\u304A\u66F8\u304D\u304F\u3060\u3055\u3044\u3002"
      }), /*#__PURE__*/_jsxs("ul", {
        children: [user && privacypolicy && /*#__PURE__*/_jsxs("li", {
          children: ["\u9001\u4FE1\u3044\u305F\u3060\u304F\u524D\u306B\u3001", /*#__PURE__*/_jsx(Link, {
            href: privacypolicy.url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: formStyles.textLink,
            children: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC"
          }), "\u306E\u5185\u5BB9\u3092\u5FC5\u305A\u304A\u8AAD\u307F\u304F\u3060\u3055\u3044\u3002\u307E\u305F\u304A\u5BA2\u69D8\u672C\u4EBA\u304C\u540C\u610F\u3057\u305F\u4E0A\u3067\u500B\u4EBA\u60C5\u5831\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002"]
        }), /*#__PURE__*/_jsx("li", {
          children: "\u5404\u9805\u76EE\u3092\u6B63\u78BA\u306B\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u304C\u4E0D\u6B63\u78BA\u306A\u5834\u5408\u306F\u3054\u8FD4\u4FE1\u3067\u304D\u307E\u305B\u3093\u3002"
        }), /*#__PURE__*/_jsx("li", {
          children: "\u56DE\u7B54\u306B\u6642\u9593\u304C\u304B\u304B\u308B\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002\u307E\u305F\u3001\u304A\u554F\u3044\u5408\u308F\u305B\u5185\u5BB9\u306B\u3088\u3063\u3066\u306F\u3054\u8FD4\u4FE1\u3067\u304D\u306A\u3044\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002\u3042\u3089\u304B\u3058\u3081\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002"
        }), /*#__PURE__*/_jsxs("li", {
          children: ["\u65E5\u672C\u8A9E\u4EE5\u5916\u306E\u304A\u554F\u3044\u5408\u308F\u305B\u306B\u306F\u304A\u5FDC\u3048\u3067\u304D\u307E\u305B\u3093\u306E\u3067\u3001\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "Please understand that all information is provided in Japanese only."]
        })]
      }), !user && privacypolicy && /*#__PURE__*/_jsx("fieldset", {
        className: formStyles.basicFieldset,
        children: /*#__PURE__*/_jsx(SingleCheckboxField, {
          ref: register,
          title: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC",
          name: "privacypolicy",
          defaultChecked: false,
          label: /*#__PURE__*/_jsxs("p", {
            className: formStyles.terms,
            children: [/*#__PURE__*/_jsx(Link, {
              href: privacypolicy.url,
              target: "_blank",
              rel: "noopener noreferrer",
              children: privacypolicy.display_name
            }), "\u3092\u78BA\u8A8D\u306E\u4E0A\u3001\u540C\u610F\u3059\u308B"]
          }),
          error: (_errors$privacypolicy = errors.privacypolicy) === null || _errors$privacypolicy === void 0 ? void 0 : _errors$privacypolicy.message,
          required: true
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: formStyles.btnArea,
      children: /*#__PURE__*/_jsx(Button, {
        type: "submit",
        fillColor: true,
        large: true,
        fontFixed: true,
        disabled: !isDirty || !isValid,
        loading: isSubmitting,
        children: "\u6B21\u3078"
      })
    })]
  });
}